import React, { /*useState,*/ useEffect, useState } from "react";
import {useStateValue} from "../../../State";
import "../vasu.css";
import VasuContainer from "../VasuContainer";

import ContentBoxMUI        from "../../../Components/ContentBoxMUI";
import Languages            from "../../../translations";
import ChildRow             from '../ChildRow';
import VasuPreparingSubPart from "./VasuPreparingSubPart";


import Box              from '@mui/material/Box'
import IconButton       from "@mui/material/IconButton";
import Link             from '@mui/material/Link'
import LockIcon         from '@mui/icons-material/Lock';
import List             from '@mui/material/List';
import ListItemButton   from '@mui/material/ListItemButton';
import ListItemIcon     from '@mui/material/ListItemIcon';
import ListItemText     from '@mui/material/ListItemText';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Typography       from "@mui/material/Typography";

const VasuPreparingPart = (props) => {

  const { state/*, actions*/ } = useStateValue();
  const VasuData = state.vasu;
  const GeneralPart = state.vasu.GeneralPart;
  const VasuPrepData = VasuData.Table1;
  

  const { history, location } = props;
  //console.log("VasuPreparingPart. MOUNT. location.state: ", location.state);

  const [ShowSlideIndex, setShowSlideIndex] = useState(-1);

  if (location.state === undefined)
  {
    //console.log("VasuPreparingPart. MOUNT. location.state === undefined. GO BACK");
    history.goBack(); 
  }
  //console.log("VasuPreparingPart. MOUNT. Table1: ", Table1);
  
  useEffect( () => {
    
    //console.log("VasuPreparingPart. useEffect. ShowSlideIndex: "+ ShowSlideIndex );

  },[ShowSlideIndex]);

  const handleBackClick = () => {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = () => {
      window.history.pushState(null, "", window.location.href);
      setShowSlideIndex(-1);
      window.onpopstate = undefined;
      window.history.back();
    };
  };

  const handleBoxClick = (index) => {
    setShowSlideIndex(index);
    handleBackClick();
  };

  if (VasuData.state === "INITIAL_STATE" || location.state === undefined)
  {
    return (<div className="VasuPreparingPart"></div>);
  }
  else
  {
    const { childpicture, childFirstName, childLastName, childColor, value} = location.state;
  
  return (
    <div className="VasuPreparingPart">
      <ContentBoxMUI>
        <Box sx ={{mt: 1}}>
          <ChildRow childpicture   = {childpicture}
                    childFirstName = {childFirstName}
                    childLastName={childLastName}
                    childColor     = {childColor}
                    FormId         = {GeneralPart.Id}
                    history        = {history}
                    value          = {value}>
          </ChildRow>
        </Box>
        

        {ShowSlideIndex === -1 ?
        <div>
          <h4 className="textCenter">1. {Languages.eduPlanTitle1}</h4>

          <div>
          
          <List className="col-12" sx={{ mt: -1}}>
            <ListItemButton className="boxed" sx={{backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(0)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={value === "new" ? Languages.VasuChildSubTitle1v2 : Languages.VasuChildSubTitle1}/>
              <ListItemIcon><ArrowForwardIosIcon fontWeight='Bold' fontSize="small"/></ListItemIcon>
            </ListItemButton>
            <ListItemButton className="boxed" sx={{ backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(1)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={value === "new" ? Languages.VasuChildSubTitle2v2 : Languages.VasuChildSubTitle2} />
              <ListItemIcon><ArrowForwardIosIcon fontWeight='Bold' fontSize="small"/></ListItemIcon>
            </ListItemButton>
            <ListItemButton className="boxed" sx={{ backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(2)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={value === "new" ? Languages.VasuChildSubTitle3v2 : Languages.VasuChildSubTitle3}/>
              <ListItemIcon><ArrowForwardIosIcon fontSize="small" /></ListItemIcon>
            </ListItemButton>
            <ListItemButton className="boxed" sx={{ backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(3)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={value === "new" ? Languages.VasuChildSubTitle4v2 : Languages.VasuChildSubTitle4}/>
              <ListItemIcon><ArrowForwardIosIcon fontSize="small" /></ListItemIcon>
            </ListItemButton>
            <ListItemButton className="boxed" sx={{ backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(4)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={value === "new" ? Languages.VasuChildSubTitle5v2 : Languages.VasuChildSubTitle5}/>
              <ListItemIcon><ArrowForwardIosIcon fontSize="small" /></ListItemIcon>
            </ListItemButton>
            {value == "old" && (
            <ListItemButton className="boxed" sx={{ backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(5)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={Languages.ManyFormsOfExpression}/>
              <ListItemIcon><ArrowForwardIosIcon fontSize="small" /></ListItemIcon>
            </ListItemButton>
            )}
            {value == "old" && (
            <ListItemButton className="boxed" sx={{ backgroundColor: "#a6dee0", borderRadius: .5, mt: 1.5, boxShadow: 2}} onClick={(event) => handleBoxClick(6)}>
              <ListItemText 
                primaryTypographyProps={{fontWeight: 'Bold', fontSize: 16, ml: 2}} primary={Languages.VasuChildSubTitle7}/>
              <ListItemIcon><ArrowForwardIosIcon fontSize="small" /></ListItemIcon>
            </ListItemButton>
            )}
            {VasuPrepData.VasuPrepGuideText !== null &&
                    VasuPrepData.VasuPrepGuideText.length > 0 && (
                      <>
                        <Box
                          sx={{
                            backgroundColor: "#a6dee0",
                            borderRadius: 0.5,
                            mt: 5,
                            boxShadow: 2,
                            padding: "8px 15px",
                          }}
                        >
                          <Typography
                            color="textSecondary"
                            sx={{
                              textAlign: "center",
                              fontWeight: "bold",
                              fontSize: 16,
                              color: "#424242",
                            }}
                          >
                            {VasuPrepData.VasuPrepGuideText}
                          </Typography>
                        </Box>
                      </>
                    )}
          </List>
          </div>

          {GeneralPart.Locked === null ?
            <div className="fixed-bottom" style={{left:"auto", fontWeight: "bold", color: "#D500F9"}}>
              <div className="float-right">
                {Languages.logged}
                <LockIcon style={{color: "#D500F9"}} fontSize="large"></LockIcon>
              </div>
            </div>
          : null}
          
        </div>
        : 
          <VasuPreparingSubPart SelectedSlideIndex = {ShowSlideIndex} value = {value} > </VasuPreparingSubPart>
        }
     
        </ContentBoxMUI>
      </div>
  );
  }
}

export default VasuPreparingPart;